import { render, staticRenderFns } from "./moveHeadLogo.vue?vue&type=template&id=fca8dd52&scoped=true&"
import script from "./moveHeadLogo.vue?vue&type=script&lang=js&"
export * from "./moveHeadLogo.vue?vue&type=script&lang=js&"
import style0 from "./moveHeadLogo.vue?vue&type=style&index=0&id=fca8dd52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca8dd52",
  null
  
)

export default component.exports